import {Action, ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';
import * as actionsUi from './benutzer-rollen.actions.ui';

import {
    GET_BENUTZER_LISTE,
    GET_BENUTZER_LISTE_ERFOLGREICH,
    GET_BENUTZER_LISTE_FEHLER,
    GET_FUNKTIONSBEREICHE_ROLLEN,
    GET_FUNKTIONSBEREICHE_ROLLEN_ERFOLGREICH,
    GET_FUNKTIONSBEREICHE_ROLLEN_FEHLER,
    GET_ROLLE_BENUTZER,
    GET_ROLLE_BENUTZER_ERFOLGREICH,
    GET_ROLLE_BENUTZER_FEHLER,
    GET_ROLLE_BENUTZER_TOTAL,
    GET_ROLLE_BENUTZER_TOTAL_ERFOLGREICH,
    GET_ROLLE_BENUTZER_TOTAL_FEHLER,
    GetBenutzerListeErfolgreichAction,
    GetBenutzerListeFehlerAction,
    GetFunktionsbereicheRollenErfolgreichAction,
    GetRolleBenutzerErfolgreichAction,
    GetRolleBenutzerFehlerAction,
    GetRolleBenutzerTotalErfolgreichAction
} from '../../../client-ngrx/benutzerverwaltung';
import {
    Benutzer,
    FunktionsbereichRollen,
    Rolle,
    RolleBenutzer,
    RolleBenutzerTotal
} from '../../../clients/benutzerverwaltung';
import {ListInputItem} from '../../shared/sopi-list/sopi-list.model';

export interface ModuleState {
    page: PageState;
}


export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};


export interface PageState {
    // LIZENZ
    rolleBenutzerTotal: RolleBenutzerTotal;
    rolleBenutzerTotalUiLaden: boolean;
    rolleBenutzerTotalUiFehler: boolean;
    rolleBenutzerTotalIds: Array<string>;

    // FUNKTIONSBEREICH ROLLEN (LISTE)
    funktionsbereicheRollenListe: Array<FunktionsbereichRollen>;
    funktionsbereicheRollenUiLaden: boolean;
    funktionsbereicheRollenUiFehler: boolean;
    funktionsbereicheRollenUiFehlerObjekt: any;
    funktionsbereicheRollenUiSelektiert: Rolle;

    // ROLLE BENUTZER (LISTE)
    rolleBenutzerListe: Array<RolleBenutzer>;
    rolleBenutzerListeUiLaden: boolean;
    rolleBenutzerListeUiFehler: boolean;
    rolleBenutzerListeUiFehlerObjekt: any;
    rolleBenutzerListeUiSelektiert: RolleBenutzer;

    // BENUTZER (LISTE)
    benutzerListe: Array<Benutzer>;
    benutzerListeUiLaden: boolean;
    benutzerListeUiFehler: boolean;
    benutzerListeUiFehlerObjekt: any;

    selectedBenutzerIds: Array<string>;

    // VARIABLEN FÜR DIE ANZEIGE
    nichtAnzuzeigendeBenutzer: Array<string>;
    infoBenutzerAnzeigen: boolean;
    standardBenutzerAnzeigen: boolean;
}

export const initialPageState: PageState = {
    // LIZENZ
    rolleBenutzerTotal: null,
    rolleBenutzerTotalUiLaden: false,
    rolleBenutzerTotalUiFehler: false,
    rolleBenutzerTotalIds: [],

    // FUNKTIONSBEREICH ROLLEN (LISTE)
    funktionsbereicheRollenListe: [],
    funktionsbereicheRollenUiLaden: false,
    funktionsbereicheRollenUiFehler: false,
    funktionsbereicheRollenUiFehlerObjekt: null,
    funktionsbereicheRollenUiSelektiert: null,

    // ROLLE BENUTZER (LISTE)
    rolleBenutzerListe: [],
    rolleBenutzerListeUiLaden: false,
    rolleBenutzerListeUiFehler: false,
    rolleBenutzerListeUiFehlerObjekt: null,
    rolleBenutzerListeUiSelektiert: null,

    // BENUTZER (LISTE)
    benutzerListe: [],
    benutzerListeUiLaden: false,
    benutzerListeUiFehler: false,
    benutzerListeUiFehlerObjekt: null,

    selectedBenutzerIds: [],

    // VARIABLEN FÜR DIE ANZEIGE
    nichtAnzuzeigendeBenutzer: [],
    infoBenutzerAnzeigen: false,
    standardBenutzerAnzeigen: true
};

export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {

        // Page State Reset
        case actionsUi.PAGE_STATE_RESET: {
            const a = <actionsUi.PageStateResetAction>action;

            return Object.assign({}, state, <PageState>initialPageState);
        }

        // LIZENZ
        case GET_ROLLE_BENUTZER_TOTAL: {
            return Object.assign({}, state, {
                rolleBenutzerTotalUiLaden: true
            });
        }

        case GET_ROLLE_BENUTZER_TOTAL_ERFOLGREICH: {
            const a = <GetRolleBenutzerTotalErfolgreichAction>action;

            return Object.assign({}, state, {
                rolleBenutzerTotal: a.payload,
                rolleBenutzerTotalUiLaden: false,
                rolleBenutzerTotalUiFehler: false,
            });
        }

        case GET_ROLLE_BENUTZER_TOTAL_FEHLER: {
            return Object.assign({}, state, {
                rolleBenutzerTotal: null,
                rolleBenutzerTotalUiLaden: false,
                rolleBenutzerTotalUiFehler: true,
            });
        }

        // FUNKTIONSBEREICHE & ROLLEN
        case GET_FUNKTIONSBEREICHE_ROLLEN: {
            return Object.assign({}, state, {
                funktionsbereicheRollenUiLaden: true,
                funktionsbereicheRollenUiFehler: false,
                funktionsbereicheRollenUiFehlerObjekt: null,
            });
        }

        case GET_FUNKTIONSBEREICHE_ROLLEN_ERFOLGREICH: {
            const a = <GetFunktionsbereicheRollenErfolgreichAction>action;

            const newState = Object.assign({}, state, <PageState>{
                funktionsbereicheRollenListe: a.payload,
                funktionsbereicheRollenUiLaden: false,
                funktionsbereicheRollenUiFehler: false,
                funktionsbereicheRollenUiFehlerObjekt: null,
            });

            return newState;
        }

        case GET_FUNKTIONSBEREICHE_ROLLEN_FEHLER: {
            return Object.assign({}, state, {
                funktionsbereicheRollenListe: [],
                funktionsbereicheRollenUiLaden: false,
                funktionsbereicheRollenUiFehler: false,
                funktionsbereicheRollenUiFehlerObjekt: null,
                funktionsbereicheRollenUiSelektiert: null
            });
        }

        // ROLLE BENUTZER
        case GET_ROLLE_BENUTZER: {
            return Object.assign({}, state, <PageState>{
                // rolleBenutzerListe: [],
                rolleBenutzerListeUiLaden: true,
                rolleBenutzerListeUiFehler: false,
                rolleBenutzerListeUiFehlerObjekt: null,
                rolleBenutzerListeUiSelektiert: null,
            });
        }

        case GET_ROLLE_BENUTZER_ERFOLGREICH: {
            const a = <GetRolleBenutzerErfolgreichAction>action;
            return Object.assign({}, state, <PageState>{
                rolleBenutzerListe: a.payload,
                rolleBenutzerListeUiLaden: false,
                rolleBenutzerListeUiFehler: false,
                rolleBenutzerListeUiFehlerObjekt: null,
                nichtAnzuzeigendeBenutzer: a.payload.map((item) => item.benutzer_id)
            });
        }

        case GET_ROLLE_BENUTZER_FEHLER: {
            const a = <GetRolleBenutzerFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                rolleBenutzerListe: [],
                rolleBenutzerListeUiLaden: false,
                rolleBenutzerListeUiFehler: true,
                rolleBenutzerListeUiFehlerObjekt: a.payload
            });
        }

        case actionsUi.ROLLE_SETZEN: {
            const a = <actionsUi.RolleSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                funktionsbereicheRollenUiSelektiert: a.rolle,
                selectedBenutzerIds: []
            });
        }



        // BENUTZER
        case GET_BENUTZER_LISTE: {
            return Object.assign({}, state, <PageState>{
                benutzerListeUiLaden: true,
                benutzerListeUiFehler: false,
                benutzerListeUiFehlerObjekt: null
            });
        }

        case GET_BENUTZER_LISTE_ERFOLGREICH: {
            const a = <GetBenutzerListeErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                benutzerListe: a.payload,
                benutzerListeUiLaden: false,
                benutzerListeUiFehler: false,
                benutzerListeUiFehlerObjekt: null
            });
        }

        case GET_BENUTZER_LISTE_FEHLER: {
            const a = <GetBenutzerListeFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                benutzerListe: [],
                benutzerListeUiLaden: false,
                benutzerListeUiFehler: true,
                benutzerListeUiFehlerObjekt: a.payload
            });
        }

        case actionsUi.NICHT_ANZUZEIGENDE_BENUTZER_SETZEN: {
            const a = <actionsUi.NichtAnzuzeigendeBenutzerSetzenAction>action;

            if (a.nichtAnzuzeigendeBenutzer == null) {
                a.nichtAnzuzeigendeBenutzer = [];
            }
            return Object.assign({}, state, <PageState>{nichtAnzuzeigendeBenutzer: a.nichtAnzuzeigendeBenutzer});
        }

        case actionsUi.SELEKTIERTE_BENUTZER: {
            const a = <actionsUi.SelektierteBenutzerAction>action;

            return Object.assign({}, state, <PageState>{
                selectedBenutzerIds: a.payload
            });
        }

        case actionsUi.SETZE_INFO_BENUTZER_ANZEIGEN: {
            const a = <actionsUi.SetzeInfoBenutzerAnzeigenAction>action;

            return Object.assign({}, state, <PageState>{
                infoBenutzerAnzeigen: a.payload
            });
        }

        case actionsUi.SETZE_STANDARD_BENUTZER_ANZEIGEN: {
            const a = <actionsUi.SetzeStandardBenutzerAnzeigenAction>action;

            return Object.assign({}, state, <PageState>{
                standardBenutzerAnzeigen: a.payload
            });
        }

        default: {
            return state;
        }
    }
}


/**
 * The createFeatureSelector function selects a piece of state from the root of the state object.
 * This is used for selecting feature states that are loaded eagerly or lazily.
 */
export const getModuleState = createFeatureSelector<ModuleState>('BenutzerRollenPage');

export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

// LIZENZ
export const getRolleBenutzerTotal = createSelector(getPageState, (state: PageState) => state.rolleBenutzerTotal);
export const getRolleBenutzerTotalUiLaden = createSelector(getPageState, (state: PageState) => state.rolleBenutzerTotalUiLaden);
export const getRolleBenutzerTotalUiFehler = createSelector(getPageState, (state: PageState) => state.rolleBenutzerTotalUiFehler);

// FUNKTIONSBEREICHE
export const getFunktionsbereicheRollenListe = createSelector(getPageState, (state: PageState) => state.funktionsbereicheRollenListe);
export const getFunktionsbereicheRollenUiLaden = createSelector(getPageState, (state: PageState) => state.funktionsbereicheRollenUiLaden);
export const getFunktionsbereicheRollenUiFehler = createSelector(getPageState, (state: PageState) => state.funktionsbereicheRollenUiFehler);
export const getFunktionsbereicheRollenUiFehlerObjekt = createSelector(getPageState, (state: PageState) => state.funktionsbereicheRollenUiFehlerObjekt);
export const getFunktionsbereicheRollenUiSelektiert = createSelector(getPageState, (state: PageState) => state.funktionsbereicheRollenUiSelektiert);

export const getFunktionsbereicheRollen = createSelector(getPageState, (state: PageState) => {
    const res = [];
    state.funktionsbereicheRollenListe.forEach((fb) => {
        fb.rollen.forEach(rolle => {
            res.push(<ListInputItem>{
                groupId: fb.funktionsbereich.funktionsbereich_id,
                groupTitle: fb.funktionsbereich.titel,
                itemId: rolle.rolle_id,
                itemTitle: rolle.titel,
                item: rolle,
            });
        });
    });
    return res;
});


// ROLLE BENUTZER
export const getRolleBenutzerListe = createSelector(getPageState, (state: PageState) => {
    const rolleBenutzerListe = [...state.rolleBenutzerListe];
    return rolleBenutzerListe.sort((a, b) => {
        if (a.benutzer_name.toLowerCase() < b.benutzer_name.toLowerCase()) {
            return -1;
        }
        if (a.benutzer_name.toLowerCase() > b.benutzer_name.toLowerCase()) {
            return 1;
        }
        return 0;
    });
});
export const getRolleBenutzerListeUiLaden = createSelector(getPageState, (state: PageState) => state.rolleBenutzerListeUiLaden);
export const getRolleBenutzerListeUiFehler = createSelector(getPageState, (state: PageState) => state.rolleBenutzerListeUiFehler);
export const getRolleBenutzerListeUiFehlerObjekt = createSelector(getPageState, (state: PageState) => state.rolleBenutzerListeUiFehlerObjekt);
export const getRolleBenutzerListeUiSelektiert = createSelector(getPageState, (state: PageState) => state.rolleBenutzerListeUiSelektiert);

// BENUTZER
export const getBenutzerListe = createSelector(getPageState, (state: PageState) => {
    const benutzerListe = [...state.benutzerListe];
    return benutzerListe.sort((a, b) => {
        if ((a.nachname.toLowerCase() + a.vorname.toLowerCase()) < (b.nachname.toLowerCase() + b.vorname.toLowerCase())) {
            return -1;
        }
        if ((a.nachname.toLowerCase() + a.vorname.toLowerCase()) > (b.nachname.toLowerCase() + b.vorname.toLowerCase())) {
            return 1;
        }
        return 0;
    });
});

export const getInfoBenutzerAnzeigen = createSelector(getPageState, (state: PageState) => state.infoBenutzerAnzeigen);
export const getStandardBenutzerAnzeigen = createSelector(getPageState, (state: PageState) => state.standardBenutzerAnzeigen);

export const getBenutzerListeUi = createSelector(getPageState, (state: PageState) => {
    let liste = Object.assign([], state.benutzerListe);

    if (!state.infoBenutzerAnzeigen) {
        liste = liste.filter(item => !item.ist_info_benutzer);
    }

    if (!state.standardBenutzerAnzeigen) {
        liste = liste.filter(item => !item.ist_benutzer);
    }

    return liste.map(item => <ListInputItem>{
        groupId: item.display_nachname_vorname.substring(0, 1).toUpperCase(),
        groupTitle: item.display_nachname_vorname.substring(0, 1).toUpperCase(),
        itemId: item.benutzer_id,
        itemTitle: item.display_nachname_vorname,
        item: item,
    }).filter((item) => state.nichtAnzuzeigendeBenutzer.findIndex((id) => id === item.itemId) === -1);
});
export const getBenutzerListeUiLaden = createSelector(getPageState, (state: PageState) => state.benutzerListeUiLaden);
export const getBenutzerListeUiFehler = createSelector(getPageState, (state: PageState) => state.benutzerListeUiFehler);
export const getBenutzerListeUiFehlerObjekt = createSelector(getPageState, (state: PageState) => state.benutzerListeUiFehlerObjekt);
export const getNichtAnzuzeigendeBenutzer = createSelector(getPageState, (state: PageState) => state.nichtAnzuzeigendeBenutzer);
export const getSelectedBenutzerIds = createSelector(getPageState, (state: PageState) => state.selectedBenutzerIds);

export const getBenutzerZuordnenAktiv = createSelector(getRolleBenutzerTotal, getSelectedBenutzerIds,
    (rolleBenutzer: RolleBenutzerTotal, selectedBenutzerIds: Array<string>): boolean => {
    if (rolleBenutzer === null || rolleBenutzer === undefined) {
        return false;
    }
    if (rolleBenutzer.benutzer_gesamt + rolleBenutzer.info_benutzer_gesamt < rolleBenutzer.benutzer_erlaubt + rolleBenutzer.info_benutzer_erlaubt) {
        return true;
    }

    let ret = false;

    if (selectedBenutzerIds.length > 0) {
        ret = true;
        (selectedBenutzerIds.forEach(x => {
            if (rolleBenutzer.benutzer_ids.findIndex(y => x === y) <= -1) {
                ret = false;
            }
        }));
    }

    return ret;
});
